export const environment = {
  production: false,
  name: 'release',
  apiUrl: 'https://api.airgateway.live/',
  keycloakUrl: 'https://auth.airgateway.live',
  tracerUrl: 'https://tracer-api.airgateway.live',
  bpUrl: 'https://web.bookingpad.live/',
};
